import { render, staticRenderFns } from "./PscActionCodeComponent.vue?vue&type=template&id=6dbaad12&scoped=true&"
import script from "./PscActionCodeComponent.vue?vue&type=script&lang=js&"
export * from "./PscActionCodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbaad12",
  null
  
)

export default component.exports